import { Button, Icon, Input } from '@iwoca/orion';

import styles from './CredentialsPage.module.css';
import {
  fetchPostIwocapaySellerEcommerceCredentials,
  useGetIwocapaySellerEcommerceCredentials,
} from '../../../api/lending/lapiHooks';
import { copy } from '../../../components/util/copy';
import { useStateKey } from '../../../hooks/useStateKey.hook';

const CREDENTIALS_STATUS = {
  ADDENDUM_NOT_SIGNED: 'addendum_not_signed',
  ADDENDUM_SIGNED: 'addendum_signed',
  HAS_CREDENTIALS: 'has_credentials',
} as const;

export const CredentialsPage = () => {
  const { stateKey } = useStateKey();
  const {
    ecommerceCredentials,
    ecommerceCredentialsError,
    loadingEcommerceCredentials,
    refetchEcommerceCredentials,
  } = useGetIwocapaySellerEcommerceCredentials();
  const hasCredentials = ecommerceCredentials !== null;
  const hasSignedAddendum =
    !loadingEcommerceCredentials &&
    ecommerceCredentialsError !== 'API addendum has not been signed';

  const getStatus = () => {
    if (hasCredentials) return CREDENTIALS_STATUS.HAS_CREDENTIALS;
    if (hasSignedAddendum) return CREDENTIALS_STATUS.ADDENDUM_SIGNED;
    return CREDENTIALS_STATUS.ADDENDUM_NOT_SIGNED;
  };
  const status = getStatus();

  const requestCredentials = async () => {
    await fetchPostIwocapaySellerEcommerceCredentials({
      stateKey: stateKey!,
      redirectUrl: 'https://www.quickfile.co.uk/payments/iwoca',
    });
    await refetchEcommerceCredentials();
  };

  if (loadingEcommerceCredentials || !stateKey) return null;

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.header}>
          <h2 className={styles.title}>Generate your API credentials</h2>
          <p className={styles.description}>
            Copy your API credentials and add them to your integration.
          </p>
        </div>
        {status === CREDENTIALS_STATUS.HAS_CREDENTIALS && <Credentials />}
        {status === CREDENTIALS_STATUS.ADDENDUM_SIGNED && (
          <Button onClick={requestCredentials}>Generate API credentials</Button>
        )}
        {status === CREDENTIALS_STATUS.ADDENDUM_NOT_SIGNED && (
          <>
            <p className={styles.error}>
              Please talk to your account manager to sign the API addendum and
              request credentials.
            </p>
            <Button disabled={true}>Generate API credentials</Button>
          </>
        )}
      </div>
    </div>
  );
};

export const Credentials = () => {
  const { ecommerceCredentials } = useGetIwocapaySellerEcommerceCredentials();

  return (
    <>
      <CredentialsField
        label="Seller Id"
        value={ecommerceCredentials!.seller_id}
      />
      <CredentialsField label="Token" value={ecommerceCredentials!.token} />
    </>
  );
};

const CredentialsField = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className={styles.credentialField}>
      <Input
        wrapperClassName={styles.credentialsInput}
        label={label}
        value={value}
        disabled={true}
        className="fs-mask"
      />
      <Button
        variant="tertiary"
        iconOnly={true}
        onClick={() => copy(value)}
        aria-label={`Copy ${label}`}
        className="fs-mask"
      >
        <Icon icon="clipboard" />
      </Button>
    </div>
  );
};
